const ABOUT_EVENT = 'clas:show-about';

const openExternal = (url) => {
  const newWindow = window.open(url, '_blank', 'noopener,noreferrer');
  if (newWindow) {
    newWindow.opener = null;
  }
};

const downloadBlob = (blob, fileName) => {
  const blobUrl = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = blobUrl;
  link.setAttribute('download', fileName);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(blobUrl);
};

const showAbout = () => {
  window.dispatchEvent(new CustomEvent(ABOUT_EVENT));
};

const onShowAbout = (callback) => {
  window.addEventListener(ABOUT_EVENT, callback);

  return () => {
    window.removeEventListener(ABOUT_EVENT, callback);
  };
};

const reload = () => {
  window.location.reload();
};

const browserPlatform = {
  downloadBlob,
  onShowAbout,
  openExternal,
  reload,
  showAbout,
};

export default browserPlatform;
